var React = require('react');

function Box (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M512 224v240a48 48 0 0 1-48 48H48a48 48 0 0 1-48-48V224z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M53.1 32.8L2.5 184.6c-.8 2.4-.8 4.9-1.2 7.4H240V0H98.6a47.87 47.87 0 0 0-45.5 32.8zm456.4 151.8L458.9 32.8A47.87 47.87 0 0 0 413.4 0H272v192h238.7c-.4-2.5-.4-5-1.2-7.4z","className":"fa-primary","key":2})]);
}

Box.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = Box;

Box.default = Box;
